import { SET_BIDS_TEXT_VALUE } from "../action";

export function setBidsTextValue(textKey, textValue, bidNum) {
  return (dispatch) => {
    dispatch({
      type: SET_BIDS_TEXT_VALUE,
      payload: { textKey, textValue, bidNum },
    });
  };
}
